document.addEventListener('DOMContentLoaded', function() {
  // Check if the element with the specified class exists
  const table = document.querySelector('.js-flight-table-operators');
  if (!table) return; // If it does not exist, stop code execution here

  // Get the initial number of rows to display
  const initialRowsToShow = parseInt(table.getAttribute('data-rows'));

  // Focus only on the rows within <tbody>
  const rows = table.querySelectorAll('tbody tr');
  rows.forEach((row, index) => {
    if (index >= initialRowsToShow) {
      row.style.display = 'none'; // Hide rows exceeding the initial limit
    }
  });

  // Update the button
  const loadMoreButton = document.getElementById('load-more-rows-btn');
  const rowsPerLoad = parseInt(loadMoreButton.getAttribute('data-rows-per-load'));
  updateButton(loadMoreButton, rowsPerLoad, rows.length - initialRowsToShow);

  // Add event listener to the button
  loadMoreButton.addEventListener('click', function() {
    let shownRows = 0;
    let totalShown = 0;

    // Count how many rows are currently displayed
    rows.forEach(row => {
      if (row.style.display !== 'none') totalShown++;
    });

    // Display the specified number of additional rows
    rows.forEach(row => {
      if (row.style.display === 'none' && shownRows < rowsPerLoad) {
        row.style.display = '';
        shownRows++;
      }
    });

    // Update the button after loading rows
    updateButton(this, rowsPerLoad, rows.length - totalShown - shownRows);
  });
});

function updateButton(button, rowsPerLoad, remainingRows) {
  const rowsToShowNext = Math.min(rowsPerLoad, remainingRows);
  if (rowsToShowNext > 0) {
    button.textContent = `Carica altre ${rowsToShowNext} righe`;
  } else {
    button.style.display = 'none'; // Hide the button if no more rows to load
  }
}
